import { adjust, curry, fromPairs, map, toLower, toPairs } from 'ramda';
import getUrlParams from './getUrlParams';
//    mapKeys :: (String -> String) -> Object -> Object
// @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
const mapKeys = curry((fn, obj) => fromPairs(map(adjust(0, fn), toPairs(obj))));
const getUrlParamsToLower = () => mapKeys(toLower, getUrlParams());
export default getUrlParamsToLower;
//# sourceMappingURL=getUrlParamsToLower.js.map